import { client } from "Service/axios";
import {
  SERVICES_PAYMENT_TYPE,
  SERVICES_PAYMENT_TYPE_CREATE,
} from "Shared/Constants/apiRequest";
import { PaymentTypeRequest } from "Shared/Types/fleetmanagementapi";
import { TPaymentTypeSearchParams } from "Shared/Types/paymentType";

class Payment {
  getPaymentType(params: TPaymentTypeSearchParams | null) {
    return client.get<any>(SERVICES_PAYMENT_TYPE, { params });
  }

  addPaymentType(data: PaymentTypeRequest) {
    return client.post<any>(SERVICES_PAYMENT_TYPE_CREATE, data);
  }
}

export default Payment;
